import { useRouteError } from 'react-router-dom'
import { useEffect } from 'react'
import { captureError } from '@/lib/errorReporting'
import { isApiError } from '@/lib/api/client'
import { ErrorState } from '@/design'
import { PageContainer } from '@/design'

/** Per-route error boundary (amendment A3): React Router renders this when a screen throws. */
export function RouteErrorBoundary() {
  const error = useRouteError()

  useEffect(() => {
    captureError(error, { boundary: 'route' })
  }, [error])

  const requestId = isApiError(error) ? error.requestId : undefined
  const message = isApiError(error) ? error.detail : 'This section failed to load.'

  return (
    <PageContainer>
      <ErrorState title="Couldn't load this page" message={message} requestId={requestId} onRetry={() => window.location.reload()} />
    </PageContainer>
  )
}
